import { Injectable } from '@angular/core';
import * as _moment from 'moment';

@Injectable()
export class AppConstMessages {

  public errorMsgRequiredInfo = 'Please select required information';

  public uploadFileSuccess = 'File successfully uploaded.';
  public deleteFileSuccess = 'File successfully deleted';
  public errorMsgFileUpload = 'Please select file to upload';
  public errorMsgFileRequired = 'Please select the file';
  public errorMsgFileExtension = 'Upload valid image or file, Only .PNG, .JPG, .JPEG and .PDF file are allowed';

  public confirmMsgDeleteFile = 'Are you sure you want to delete this file?';
  public confirmMsgContinue = 'Are you sure you want to continue? Any unsaved changes will be lost.';

  public deleteConfirm = 'Are you sure you want to delete ';
  public removeConfirm = 'Are you sure you want to remove ';
  public removeSuccess = ' successfully removed';
  public isRequired = ' is required';
  public maxDate=" feature date not allow";
  public maxYearDate=" please add valid date";
  public minDate="please check date ";
  public isNotValid = 'is not valid';

  public numericFormat = 'Invalid format, please enter only digit(99999)';
  public weightFormat = 'Invalid format, please enter only digit(99999.99)';
  public needPermission='You need permission to perform this action';
  public negativeValue = 'Negative value not allowed';
  public updateSuccess = 'Record successfully updated';
  public insertSuccess = 'Record successfully inserted';
  public drumNumberInvalid = 'Invalid format, please enter value like(D288172-1)';
  public zipcodeInvalid = 'Invalid zip code';
  public lockerAccessTimeInvalid ='Selected Time Accessed Is Greater Then Current Time.';
  public discrepancyLimitMsg ='Discrepancy is within acceptable limits';
  public discrepancyExeedMsg ='Discrepancy exceeds acceptable limits';

  public decimalWarning1 ='Invalid format, please enter only digit(9999999999.9)';
  public decimalWarning2 ='Invalid format, please enter only digit(9999999999.99)';
  public decimalWarning3 ='Invalid format, please enter only digit(9999999999.999)';
  public decimalWarning4 ='Invalid format, please enter only digit(9999999999.9999)';
  public decimalWarning5 ='Invalid format, please enter only digit(9999999999.99999)';

  public uploadDBErrorMessage = 'An error occurred while uploading the database file';
  public exportDBErrorMessage = 'An error occurred while exporting the database';
  public regenerateDBErrorMessage = 'An error occurred while regenerating the database';
}
